/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/openfeign/ticket/hasPlaced": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["hasPlaced"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/ticket/copyTradeCount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["batchGetCopyTradeCount"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/order/tickets/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 注单状态同步 */
        post: operations["syncTickets"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/order/tickets/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 注单状态同步 */
        post: operations["syncTickets_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/order/tickets/cashout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 设置注单为cashout
         * @description 修改注单状态为cashout并设置金额、时间
         */
        post: operations["cashout"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/order/tickets/cashout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 设置注单为cashout
         * @description 修改注单状态为cashout并设置金额、时间
         */
        post: operations["cashout_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/order/selection/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 选择结算同步 */
        post: operations["syncSelection"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/order/selection/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 选择结算同步 */
        post: operations["syncSelection_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/internal/kafka/test/report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 发送测试消息到报告集群
         * @description 发送消息到 report.topic.name Topic
         */
        post: operations["testReportCluster"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/internal/kafka/test/refresh-partitions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 刷新 Topic 分区信息
         * @description 手动刷新 Topic 分区数量缓存
         */
        post: operations["refreshPartitions"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/internal/kafka/test/primary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 发送测试消息到主集群
         * @description 发送消息到 order_center_events Topic
         */
        post: operations["testPrimaryCluster"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/place": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 创建下注订单
         * @description 根据用户选择的投注项创建下注订单
         */
        post: operations["createOrderUserPlace"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/maxStake": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 查询最大可下注额
         * @description 镜像创建订单逻辑，调用MBS最大下注接口并返回系统自定义包装对象
         */
        post: operations["maxStake"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/cart": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 保存购物车V2
         * @description 统一的购物车和购物车项操作接口（V2结构）
         */
        post: operations["saveCart"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/cart/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 删除指定购物车V2
         * @description 删除指定的购物车及其所有购物车项（V2）
         */
        post: operations["deleteCart"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/cart/clear": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 清空用户购物车V2
         * @description 清空用户的所有购物车（V2）
         */
        post: operations["clearUserCarts"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/tickets/cashout/process": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 现金出执行
         * @description 确认现金出，返回本地DTO
         */
        post: operations["processCashout"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/place": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 创建下注订单
         * @description 根据用户选择的投注项创建下注订单
         */
        post: operations["createOrder_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/maxStake": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 查询最大可下注额
         * @description 镜像创建订单逻辑，调用MBS最大下注接口并返回系统自定义包装对象
         */
        post: operations["maxStake_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/carts/clear": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 清空用户购物车
         * @description 清空用户的所有购物车
         */
        post: operations["clearUserCarts_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/cart": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 保存购物车
         * @description 统一的购物车和购物车项操作接口，支持创建、修改、删除
         */
        post: operations["saveCart_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/cart/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 删除指定购物车
         * @description 删除指定的购物车及其所有购物车项
         */
        post: operations["deleteCart_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/i18n/syncTranslations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 同步Crowdin翻译
         * @description 从Crowdin企业版拉取翻译并入库；不传参数默认同步系统所有源文本，传入texts则仅同步这些文本
         */
        post: operations["syncTranslations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/i18n/init": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 初始化翻译字典-- 个人版本
         * @deprecated
         * @description 从MBS错误码映射与组合枚举提取源文案，调用Crowdin获取多语言翻译并入库
         */
        post: operations["init"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/i18n/initCrowdin": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传源文本到Crowdin
         * @description 上传系统默认源文本到Crowdin企业版；传入texts则仅上传这些文本
         */
        post: operations["initCrowdin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/internal/kafka/test/partitions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取 Topic 分区信息
         * @description 查看各 Topic 的分区数量
         */
        get: operations["getPartitionInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/internal/kafka/test/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Kafka 集群健康检查
         * @description 检查两个 Kafka 集群的连接状态
         */
        get: operations["healthCheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/internal/kafka/test/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取 Kafka 集群配置信息
         * @description 查看当前配置的 Kafka 集群地址
         */
        get: operations["getClusterConfig"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/virtual-bet-user/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据用户ID查询
         * @description 根据用户ID查询虚拟投注用户信息
         */
        get: operations["getByUserId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/virtual-bet-user/random": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 随机查询用户
         * @description 随机查询指定数量的启用虚拟投注用户
         */
        get: operations["randomUsers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/virtual-bet-user/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询所有用户
         * @description 查询所有虚拟投注用户（包含禁用）
         */
        get: operations["listAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/virtual-bet-user/active": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询所有启用用户
         * @description 查询所有启用状态的虚拟投注用户
         */
        get: operations["listActiveUsers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/combo/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取系统组合玩法列表
         * @description 返回所有支持的系统组合玩法及其元数据
         */
        get: operations["listComboTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/v2/cart/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询用户购物车V2
         * @description 查询用户的所有购物车（V2结构）
         */
        get: operations["getUserCarts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/tickets/page": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询注单列表
         * @description 分页查询用户的注单列表，支持多种筛选条件和递归查询系统投注
         */
        get: operations["getUserTicketsPage"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/tickets/cashout/amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 现金出询价
         * @description 根据注单号进行现金出询价，返回本地DTO
         */
        get: operations["getCashoutAmount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/carts/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询用户购物车
         * @description 查询用户的所有购物车
         */
        get: operations["getUserCarts_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/tickets/recommendation/amounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取推荐金额
         * @description 根据币种获取推荐金额配置
         */
        get: operations["getTicketsRecommendationAmounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/tickets/page": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询注单列表
         * @description 分页查询用户的注单列表
         */
        get: operations["getTickets_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/tickets/leaderboard/winrate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询胜率排行榜
         * @description 查询胜率排行榜Top N
         */
        get: operations["getWinRateLeaderboard"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/tickets/leaderboard/turnover": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询赢金排行榜
         * @description 查询近7天赢金排行榜Top N
         */
        get: operations["getTurnoverLeaderboard"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/tickets/combo/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取系统组合玩法列表
         * @description 返回所有支持的系统组合玩法及其元数据
         */
        get: operations["getTicketsComboTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/tickets/cashout/rules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取Cashout规则
         * @description 获取支持cashout的体育类型和玩法组合规则，前端可据此判断注单是否支持cashout
         */
        get: operations["getTicketsCashoutRules"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/order/user/tickets/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询注单数量
         * @description 查询用户在指定筛选条件下的注单数量
         */
        get: operations["getUserTicketsCount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        SingleResponseObject: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        HasPlacedRequest: {
            /** Format: int64 */
            userId: number;
            matchIds: string[];
        };
        SingleResponseMapStringBoolean: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: {
                [key: string]: boolean;
            };
        };
        CopyTradeCountRequest: {
            items: components["schemas"]["Item"][];
        };
        Item: {
            /** Format: int64 */
            userId?: number;
            copySourceNo: string;
            /** Format: int32 */
            copySourceType: number;
            /** Format: int64 */
            earliestMatchStart?: number;
        };
        CopyTradeCountResponse: {
            items: components["schemas"]["Item"][];
        };
        SingleResponseCopyTradeCountResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CopyTradeCountResponse"];
        };
        BetsTicketSyncRequest: {
            requestId: string;
            ticketNo: string;
            /** Format: int32 */
            settledStatus: number;
            settledAmount: number;
            /** Format: int64 */
            settledTime: number;
            subTickets: components["schemas"]["SubTicket"][];
            selections: components["schemas"]["Selection"][];
        };
        Selection: {
            oddsCode: string;
            /** Format: int32 */
            settledStatus: number;
            /** Format: int64 */
            settledTime: number;
        };
        SubTicket: {
            ticketNo: string;
            /** Format: int32 */
            settledStatus: number;
            settledAmount: number;
            /** Format: int64 */
            settledTime: number;
        };
        SingleResponseSyncResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["SyncResponse"];
        };
        SyncResponse: {
            success: boolean;
            message: string;
        };
        TicketCashoutRequest: {
            ticketNo: string;
            amount: number;
            paymentNo: string;
        };
        SingleResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        BetsSelectionSyncRequest: {
            requestId: string;
            ticketNo: string;
            oddsCode: string;
            /** Format: int32 */
            settledStatus: number;
            /** Format: int64 */
            settledTime: number;
        };
        TestMessage: {
            key: string;
            content: string;
            /** Format: int64 */
            partitionKey: number;
            metadata: {
                [key: string]: Record<string, never>;
            };
        };
        /** @description 投注选项请求 */
        BetsSelectionV2Request: {
            /**
             * @description 比赛id
             * @example 1
             */
            matchId: string;
            /**
             * @description 赔率选项代码
             * @example 1
             */
            code: string;
            /**
             * @description 赔率值
             * @example 1.85
             */
            odds: number;
        };
        /** @description 投注选项请求 */
        BetsTicketRequest: {
            /**
             * @description 注单类型
             * @example SINGLE
             * @enum {string}
             */
            itemType: "SINGLE" | "COMBO" | "SYSTEM" | "CUSTOM";
            /**
             * @description 组合类型 system类型下必传
             * @example 2/3
             * @enum {string}
             */
            comboType?: "2/3" | "3/4" | "4/5" | "Trixie" | "Yankee";
            /**
             * @description 赔率值
             * @example 1.85
             */
            odds: number;
            /**
             * @description 注单金额
             * @example 100
             */
            stake?: number;
            /** @description 注单列表 */
            selections: components["schemas"]["BetsSelectionV2Request"][];
            /**
             * Format: int32
             * @description 跟注来源类型：11=BETTING_HEIGHT_LIGHT 12=HOT_COMBO
             */
            copyType?: number;
            /** @description 被跟单的来源号 */
            copyNo?: string;
        };
        /** @description 创建下注订单请求V2 */
        PlaceBetsOrderV2Request: {
            /**
             * @description 投注类型
             * @example SINGLE
             * @enum {string}
             */
            betType: "SINGLE" | "COMBO" | "SYSTEM";
            /**
             * @description 总投注金额
             * @example 100
             */
            totalStake: number;
            /**
             * @description 货币类型
             * @example USD
             */
            currency: string;
            /**
             * Format: int32
             * @description 是否接受赔率变化
             * @enum {integer}
             */
            acceptOddsChange: 0 | 1 | 2;
            /**
             * @description 支付方式
             * @example BALANCE or BONUS
             */
            paymentMethod?: string;
            /**
             * Format: int32
             * @description 是否使用信用资产
             */
            useCredit?: number;
            /** @description 注单列表 */
            bets: components["schemas"]["BetsTicketRequest"][];
        };
        /** @description Failed selection information */
        FailedSelection: {
            /** @description Odds code */
            oddsCode: string;
            /** Format: int32 */
            mbsErrCode: number;
            /** @description Failure reason */
            failureReason: string;
            /** @description limitAmount */
            limitAmount: number;
        };
        /** @description 创建下注订单响应 */
        PlaceBetsOrderV2Response: {
            /** @description 订单号 */
            orderNo: string;
            /**
             * Format: int32
             * @description 订单状态
             */
            status: number;
            /** @description 下注类型 */
            betType: string;
            /** @description 实际支付金额 */
            actualPayAmount: number;
            /** @description 原始请求金额 */
            originalAmount: number;
            /**
             * Format: int32
             * @description 成功的选项数量
             */
            successSelectionCount: number;
            /** @description 失败的选项信息 */
            failedSelections: components["schemas"]["FailedSelection"][];
            /** @description 失败信息 */
            failureReason: string;
            /**
             * Format: int32
             * @description 本地错误码（映射自MBS错误码）
             */
            localErrCode: number;
            /** @description 用户提示主标题 */
            userMsgTitle: string;
            /** @description 用户提示副标题 */
            userMsgSubTitle: string;
            /** @description 推荐金额，非mbs金额报错为空 */
            limitAmount: number;
            allFailedSelections: components["schemas"]["BetSelection"][];
        };
        SingleResponsePlaceBetsOrderV2Response: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PlaceBetsOrderV2Response"];
        };
        /** @description 最大可下注额查询响应 */
        MaxStakeApiResponse: {
            /** @description 投注类型 */
            betType: string;
            /** @description bet列表（自定义格式，不暴露三方类型） */
            bets: components["schemas"]["MaxStakeBetDto"][];
        };
        /** @description 最大下注-Bet信息（自定义） */
        MaxStakeBetDto: {
            /** @description 赛事ID */
            matchId: string;
            /** @description 金额 */
            amount: number;
            /** @description oddsCode */
            oddsCode: string;
        };
        SingleResponseMaxStakeApiResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MaxStakeApiResponse"];
        };
        /** @description 购物车项请求 */
        BetCartItemRequest: {
            /**
             * @description 选项类型NORMAL CUSTOM
             * @enum {string}
             */
            itemType?: "NORMAL" | "CUSTOM";
            /** @description 投注选项-赔率值 */
            odds: number;
            /** @description 投注金额 COMBO和SYSTEM 不要传 */
            stake: number;
            /** @description 购物车项-选项列表 */
            selections?: components["schemas"]["BetCartItemSelectionRequest"][];
        };
        /** @description 购物车项-选项 请求 */
        BetCartItemSelectionRequest: {
            /** @description 比赛ID */
            matchId: string;
            /** @description 投注选项-赔率代码 */
            code: string;
            /** @description 投注选项-赔率值 */
            odds: number;
        };
        /** @description 购物车V2请求 */
        BetsCartV2Request: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId?: number;
            /** @description 购物车编号（更新时需要，新增时不需要） */
            cartNo?: string;
            /**
             * @description 玩法类型：SINGLE, COMBO
             * @enum {string}
             */
            betType?: "SINGLE" | "COMBO" | "SYSTEM";
            /**
             * @description 组合类型 非system类型不要传
             * @example 2/3
             * @enum {string}
             */
            comboType?: "2/3" | "3/4" | "4/5" | "Trixie" | "Yankee";
            /** @description 总投注金额 要传准 */
            totalStake?: number;
            /** @description 货币类型 */
            currency?: string;
            /**
             * Format: int32
             * @description 是否接受赔率变化
             */
            acceptOddsChange: number;
            /** @description 购物车-项列表 */
            items?: components["schemas"]["BetCartItemRequest"][];
        };
        /** @description 购物车项响应 */
        BetsCartItemSelectionResponse: {
            /** @description 联赛比赛ID */
            matchId: string;
            /** @description marketId */
            marketId: string;
            /** @description marketName */
            marketName: string;
            /** @description Specifiers参数 */
            specifiers: string;
            /** @description 赔率代码 */
            code: string;
            /** @description outcomeId */
            outcomeId: string;
            /** @description outcomeName */
            outcomeName: string;
            /** @description colName */
            colName: string;
            /**
             * Format: int32
             * @description 盘口状态：1=active, -1=suspended, 0=deactivated, -2=handed_over, -3=settled, -4=cancelled
             */
            status: number;
            /**
             * Format: int32
             * @description 选项状态：1=active, 0=not active
             */
            active: number;
            /** @description 赔率值 */
            odds: number;
            /** @description 当前最新赔率值 */
            newOdds: number;
            /**
             * Format: int32
             * @description 盘口类型：0=赛前盘 1=滚球盘
             */
            phase: number;
        };
        /** @description 购物车项响应 */
        BetsCartItemV2Response: {
            /**
             * @description 选项类型NORMAL CUSTOM
             * @enum {string}
             */
            itemType: "NORMAL" | "CUSTOM";
            /** @description 购物车编号 */
            cartNo: string;
            /** @description 购物车项编号 */
            cartItemNo: string;
            /** @description 赔率值 */
            odds: number;
            /** @description 投注金额 */
            stake: number;
            /**
             * Format: int64
             * @description 添加时间
             */
            addedTime: number;
            /** @description 选项-赔率详情 */
            selections: components["schemas"]["BetsCartItemSelectionResponse"][];
        };
        /** @description 购物车响应 */
        BetsCartV2Response: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 购物车编号 */
            cartNo: string;
            /** @description 投注类型：SINGLE, COMBO */
            betType: string;
            /** @description 串关组合类型，如3串1, 5串10 */
            comboType: string;
            /** @description 总投注金额 */
            totalStake: number;
            /** @description 货币类型 */
            currency: string;
            /**
             * Format: int64
             * @description 创建时间
             */
            createdTime: number;
            /**
             * Format: int64
             * @description 更新时间
             */
            updatedTime: number;
            /**
             * Format: int32
             * @description 0 接受最新 1 不接受任何变化 2 只接受更高赔率
             */
            acceptOddsChange: number;
            /** @description 购物车项列表 */
            items: components["schemas"]["BetsCartItemV2Response"][];
        };
        SingleResponseBetsCartV2Response: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BetsCartV2Response"];
        };
        /** @description 现金出执行请求 */
        CashoutProcessApiRequest: {
            /** @description 注单号 */
            ticketNo: string;
            /** @description 现金出金额 */
            amount: number;
        };
        /** @description 现金出执行响应 */
        CashoutProcessApiResponse: Record<string, never>;
        SingleResponseCashoutProcessApiResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CashoutProcessApiResponse"];
        };
        /** @description 投注选项请求 */
        BetsSelectionRequest: {
            /**
             * @description 比赛id
             * @example 1
             */
            matchId: string;
            /**
             * @description 赔率选项代码
             * @example 1
             */
            code: string;
            /**
             * @description 赔率值
             * @example 1.85
             */
            odds: number;
            /**
             * @description 下注金额
             * @example 100
             */
            stake?: number;
            /** @description 扩展信息JSON */
            ext?: string;
        };
        /** @description 创建下注订单请求 */
        PlaceBetsOrderRequest: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId?: number;
            /**
             * @description 投注类型
             * @example SINGLE
             * @enum {string}
             */
            betType: "SINGLE" | "COMBO" | "SYSTEM";
            /**
             * @description 组合类型 system类型下必传
             * @example 2/3
             * @enum {string}
             */
            comboType?: "2/3" | "3/4" | "4/5" | "Trixie" | "Yankee";
            /**
             * @description 总投注金额
             * @example 100
             */
            totalStake: number;
            /**
             * @description 货币类型
             * @example USD
             */
            currency: string;
            /**
             * Format: int32
             * @description 是否接受赔率变化
             * @enum {integer}
             */
            acceptOddsChange: 0 | 1 | 2;
            /**
             * @description 支付方式
             * @example BALANCE
             */
            paymentMethod?: string;
            /** @description 投注选项列表 */
            selections: components["schemas"]["BetsSelectionRequest"][];
            /**
             * @description 备注信息
             * @example 测试下单
             */
            remark?: string;
            /** @description 是否需要真实调用钱包扣款 */
            needPay?: boolean;
            /** @description 扩展信息JSON */
            ext?: string;
        };
        /** @description 创建下注订单响应 */
        PlaceBetsOrderResponse: {
            /** @description 订单号 */
            orderNo: string;
            /**
             * Format: int32
             * @description 订单状态
             */
            status: number;
            /** @description 下注类型 */
            betType: string;
            /** @description 实际支付金额 */
            actualPayAmount: number;
            /** @description 原始请求金额 */
            originalAmount: number;
            /**
             * Format: int32
             * @description 成功的选项数量
             */
            successSelectionCount: number;
            /** @description 失败的选项信息 */
            failedSelections: components["schemas"]["FailedSelection"][];
            /** @description 失败信息 */
            failureReason: string;
            /** @description 扩展信息JSON */
            ext: string;
            /**
             * Format: int32
             * @description 本地错误码（映射自MBS错误码）
             */
            localErrCode: number;
            /** @description 用户提示主标题 */
            userMsgTitle: string;
            /** @description 用户提示副标题 */
            userMsgSubTitle: string;
            /** @description 推荐金额，非mbs金额报错为空 */
            limitAmount: number;
        };
        SingleResponsePlaceBetsOrderResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PlaceBetsOrderResponse"];
        };
        SingleResponseString: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: string;
        };
        /** @description 购物车请求 */
        BetsCartRequest: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId?: number;
            /** @description 购物车编号（更新时需要，新增时不需要） */
            cartNo?: string;
            /**
             * @description 投注类型：SINGLE, COMBO
             * @enum {string}
             */
            betType?: "SINGLE" | "COMBO" | "SYSTEM";
            /**
             * @description 组合类型 system类型下必传
             * @example 2/3
             * @enum {string}
             */
            comboType?: "2/3" | "3/4" | "4/5" | "Trixie" | "Yankee";
            /** @description 总投注金额 */
            totalStake?: number;
            /** @description 货币类型 */
            currency?: string;
            /**
             * Format: int32
             * @description 是否接受赔率变化
             */
            acceptOddsChange: number;
            /** @description 购物车项列表 */
            items?: components["schemas"]["BetCartItemRequest"][];
            /** @description 扩展信息JSON */
            ext?: string;
        };
        /** @description 购物车项响应 */
        BetsCartItemResponse: {
            /** @description 购物车编号 */
            cartNo: string;
            /** @description 购物车项编号 */
            cartItemNo: string;
            /** @description 联赛比赛ID */
            matchId: string;
            /** @description Specifiers参数 */
            specifiers: string;
            /** @description 赔率代码 */
            code: string;
            /** @description 赔率值 */
            odds: number;
            /** @description 当前最新赔率值 */
            newOdds: number;
            /**
             * Format: int32
             * @description 0-正常1-封盘2-失效
             */
            oddsStatus: number;
            /** @description 投注金额 */
            stake: number;
            /**
             * Format: int32
             * @description 0 接受最新 1 不接受任何变化 2 只接受更高赔率
             */
            acceptOddsChange: number;
            /**
             * Format: int64
             * @description 添加时间
             */
            addedTime: number;
            /**
             * Format: int32
             * @description 状态
             */
            status: number;
            /** @description marketName */
            marketName: string;
            /** @description outcomeName */
            outcomeName: string;
            /** @description 扩展信息JSON */
            ext: string;
        };
        /** @description 购物车响应 */
        BetsCartResponse: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 购物车编号 */
            cartNo: string;
            /** @description 投注类型：SINGLE, COMBO */
            betType: string;
            /** @description 串关组合类型，如3串1, 5串10 */
            comboType: string;
            /** @description 总投注金额 */
            totalStake: number;
            /** @description 货币类型 */
            currency: string;
            /**
             * Format: int32
             * @description 状态：1-有效 0-已下单 2-已过期
             */
            status: number;
            /**
             * Format: int64
             * @description 创建时间
             */
            createdTime: number;
            /**
             * Format: int64
             * @description 更新时间
             */
            updatedTime: number;
            /** @description 购物车项列表 */
            items: components["schemas"]["BetsCartItemResponse"][];
            /** @description 扩展信息JSON */
            ext: string;
        };
        SingleResponseBetsCartResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BetsCartResponse"];
        };
        /** @description 国际化初始化请求 */
        I18nInitRequest: {
            /**
             * @description 需要翻译的文本词汇
             * @example [
             *       "下注成功",
             *       "余额不足"
             *     ]
             */
            texts: string[];
        };
        SingleResponseBoolean: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: boolean;
        };
        SingleResponseVirtualBetUserPO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VirtualBetUserPO"];
        };
        VirtualBetUserPO: {
            /** Format: int64 */
            id: number;
            /** Format: int64 */
            userId: number;
            currencies: string;
            /** Format: int32 */
            status: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
            currencyList: string[];
        };
        MultiResponseVirtualBetUserPO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VirtualBetUserPO"][];
        };
        /** @description 系统组合玩法枚举信息 */
        ComboTypeApiResponse: {
            /** @description 枚举常量名，如 SYSTEM_2_OF_3, TRIXIE */
            enumName: string;
            /** @description 展示值，如 2/3, Trixie, Yankee */
            value: string;
            /** @description 描述 */
            description: string;
            /**
             * Format: int32
             * @description 组合需要的赛事数量
             */
            eventsCount: number;
            /**
             * Format: int32
             * @description 组合拆分后生成的注数
             */
            betsCount: number;
            /**
             * Format: int32
             * @description System组合的每注选择数量（如2/3的size=2），命名组合为空
             */
            systemSize: number;
            /** @description 组合构成说明（不包含为0的项） */
            composition: string;
        };
        MultiResponseComboTypeApiResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["ComboTypeApiResponse"][];
        };
        /** @description 投注选项响应 */
        BetsSelectionResponse: {
            orderNo: string;
            selectionNo: string;
            oddsCode: string;
            oddsValue: number;
            sportId: string;
            sportName: string;
            /** Format: int64 */
            matchStartTime: number;
            basicCountry: string;
            tournamentName: string;
            matchId: string;
            matchName: string;
            homeName: string;
            awayName: string;
            marketId: string;
            marketName: string;
            specifiers: string;
            outcomeId: string;
            outcomeName: string;
            colName: string;
            /** Format: int32 */
            settledStatus: number;
            /** Format: int64 */
            settledTime: number;
        };
        BetsTicketPageResponse: {
            betTickets: components["schemas"]["BetsTicketResponse"][];
            betSelections: components["schemas"]["BetsSelectionResponse"][];
            /** Format: int64 */
            total: number;
            /** Format: int64 */
            size: number;
            /** Format: int64 */
            current: number;
            ext: string;
        };
        /** @description 注单响应 */
        BetsTicketResponse: {
            /** @description 注单编号 */
            ticketNo: string;
            /** @description 归属订单号 */
            orderNo: string;
            /** @description 用户ID */
            userId: string;
            /**
             * @description 支付方式,BALANCE or BONUS
             * @enum {string}
             */
            paymentMethod: "BALANCE" | "BONUS";
            /**
             * @description 投注类型
             * @example SINGLE
             */
            betType: string;
            /**
             * @description 投注类型
             * @example 2/3
             */
            comboType: string;
            /**
             * @description 投注类型描述
             * @example a 2/3 bet contains 3 doubles
             */
            comboTypeComposition: string;
            /** @description 注单投注金额 */
            stakeAmount: number;
            /** @description 真实本币支付金额 */
            realAmount: number;
            /** @description 授信币种金额 */
            creditAmount: number;
            /** @description 注单组合赔率 */
            oddsValue: number;
            /** @description 币种 */
            currency: string;
            /** @description 潜在收益 */
            potentialPayout: number;
            /** @description 结算中奖金额 */
            winAmount: number;
            /**
             * Format: int32
             * @description 结算状态
             */
            settledStatus: number;
            /**
             * Format: int64
             * @description 结算时间（毫秒）
             */
            settledTime: number;
            /** @description 扩展信息JSON */
            ext: string;
            /**
             * Format: int64
             * @description 创建时间
             */
            createTime: number;
            /** @description cashed out金额 */
            cashedOutAmount: number;
            /** @description 注单项--system类型会有值 其余类型不会有 */
            items: components["schemas"]["BetsTicketResponse"][];
            /** @description 选项编号列表 */
            selectionNos: string[];
        };
        SingleResponseBetsTicketPageResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BetsTicketPageResponse"];
        };
        /** @description 现金出询价响应 */
        CashoutQuoteApiResponse: {
            /** @description 现金出金额 */
            amount: number;
            /** @description 币种 */
            currency: string;
        };
        SingleResponseCashoutQuoteApiResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CashoutQuoteApiResponse"];
        };
        MultiResponseBetsCartResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BetsCartResponse"][];
        };
        /** @description 前端推荐结果展示对象 */
        FrontendRecommendationVO: {
            /**
             * @description 币种代码
             * @example USD
             */
            currency: string;
            /**
             * @description 推荐金额列表
             * @example [
             *       5,
             *       10,
             *       20,
             *       50
             *     ]
             */
            recommendedAmounts: number[];
            /**
             * Format: int64
             * @description 配置ID
             * @example 1
             */
            configId: number;
        };
        SingleResponseFrontendRecommendationVO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["FrontendRecommendationVO"];
        };
        MultiResponseWinRateRankResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["WinRateRankResponse"][];
        };
        /** @description 胜率排行榜Response */
        WinRateRankResponse: {
            /** @description 脱敏后的用户ID */
            userId: string;
            /**
             * Format: double
             * @description 命中率（<50%为null）
             */
            winRate: number;
            /**
             * Format: int32
             * @description 连中场次
             */
            consecutiveWins: number;
            unsettledTicket: components["schemas"]["BetsTicketResponse"];
            /** @description 选项集合 */
            selections: components["schemas"]["BetsSelectionResponse"][];
        };
        MultiResponseTurnoverRankResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["TurnoverRankResponse"][];
        };
        /** @description 赢金排行榜 */
        TurnoverRankResponse: {
            /** @description 用户ID */
            userId: string;
            /** @description 近7天净赚金额 */
            netWin: number;
            /** @description 货币单位，统一为USD */
            currency: string;
            unsettledTicket: components["schemas"]["BetsTicketResponse"];
            /** @description 选项集合 */
            selections: components["schemas"]["BetsSelectionResponse"][];
        };
        SingleResponseCashoutMarketRuleResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CashoutMarketRuleResponse"];
        };
        /** @description Cashout玩法规则响应 */
        CashoutMarketRuleResponse: {
            /** @description 规则列表 */
            rules: components["schemas"]["SportMarketRule"][];
            /** @description 不支持cashout的投注类型 */
            unsupportedBetTypes: string[];
        };
        /** @description 体育玩法规则 */
        SportMarketRule: {
            /** @description 体育类型ID，如 sr:sport:1 */
            sportId: string;
            /** @description 体育类型名称，如 Soccer */
            sportName: string;
            /** @description 支持的玩法列表 */
            markets: components["schemas"]["MarketInfo"][];
        };
        /** @description 玩法信息 */
        MarketInfo: {
            /** @description 玩法ID，如 1, 8, 16 */
            marketId: string;
            /** @description 玩法名称，如 1x2, Total */
            marketName: string;
        };
        BetSelection: {
            selectionNo: string;
            /** Format: int64 */
            bookmakerId: number;
            sportId: string;
            sportName: string;
            basicCountry: string;
            tournamentId: string;
            tournamentName: string;
            matchId: string;
            siteMatchId: string;
            matchName: string;
            /** Format: int64 */
            matchStartTime: number;
            homeId: string;
            homeName: string;
            awayId: string;
            awayName: string;
            productId: string;
            marketId: string;
            marketName: string;
            specifiers: string;
            /** Format: int32 */
            phase: number;
            outcomeId: string;
            outcomeName: string;
            oddsCode: string;
            oddsValue: number;
            /** Format: int32 */
            mbsErrCode: number;
            failureReason: string;
            limitAmount: number;
        };
        SingleResponseLong: {
            success: boolean;
            errCode: string;
            errMessage: string;
            /** Format: int64 */
            data: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    hasPlaced: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["HasPlacedRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    batchGetCopyTradeCount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CopyTradeCountRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCopyTradeCountResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    syncTickets: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BetsTicketSyncRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseSyncResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    syncTickets_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BetsTicketSyncRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseSyncResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    cashout: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TicketCashoutRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    cashout_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TicketCashoutRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    syncSelection: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BetsSelectionSyncRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseSyncResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    syncSelection_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BetsSelectionSyncRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseSyncResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    testReportCluster: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TestMessage"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: Record<string, never>;
                    };
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    refreshPartitions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: Record<string, never>;
                    };
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    testPrimaryCluster: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TestMessage"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: Record<string, never>;
                    };
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    createOrderUserPlace: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaceBetsOrderV2Request"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePlaceBetsOrderV2Response"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    maxStake: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaceBetsOrderV2Request"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMaxStakeApiResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    saveCart: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BetsCartV2Request"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBetsCartV2Response"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    deleteCart: {
        parameters: {
            query: {
                cartNo: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    clearUserCarts: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    processCashout: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CashoutProcessApiRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCashoutProcessApiResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    createOrder_1: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaceBetsOrderRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePlaceBetsOrderResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    maxStake_1: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaceBetsOrderRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMaxStakeApiResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    clearUserCarts_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    saveCart_1: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BetsCartRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBetsCartResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    deleteCart_1: {
        parameters: {
            query: {
                cartNo: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    syncTranslations: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["I18nInitRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    init: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["I18nInitRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    initCrowdin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["I18nInitRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getPartitionInfo: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: Record<string, never>;
                    };
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    healthCheck: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: Record<string, never>;
                    };
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getClusterConfig: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: Record<string, never>;
                    };
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getByUserId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description 用户ID
                 * @example 1001
                 */
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVirtualBetUserPO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    randomUsers: {
        parameters: {
            query?: {
                /**
                 * @description 随机用户数量
                 * @example 5
                 */
                count?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseVirtualBetUserPO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    listAll: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseVirtualBetUserPO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    listActiveUsers: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseVirtualBetUserPO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    listComboTypes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseComboTypeApiResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getUserCarts: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBetsCartV2Response"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getUserTicketsPage: {
        parameters: {
            query?: {
                /**
                 * @description 注单编号
                 * @example TK202501270001
                 */
                ticketNo?: string;
                /**
                 * @description 订单号
                 * @example ORD202501270001
                 */
                orderNo?: string;
                /** @description 投注类型列表，多个类型用逗号分隔 */
                betType?: "SINGLE" | "COMBO" | "SYSTEM";
                /**
                 * @description 结算状态列表 0:未结算 10:输 20:赢 30:半赢 40:半输 50:走盘 60:取消 70:cashed out 80:退款 100:错误
                 * @example 0, 10, 20, 30, 40, 50, 60, 70, 80, 100
                 */
                settledStatus?: number[];
                /**
                 * @description 开始时间戳（毫秒）
                 * @example 1640995200000
                 */
                startTime?: string;
                /**
                 * @description 结束时间戳（毫秒）
                 * @example 1641081600000
                 */
                endTime?: string;
                /**
                 * @description 页码，从1开始
                 * @example 1
                 */
                pageIndex?: string;
                /**
                 * @description 每页大小，最大100
                 * @example 10
                 */
                pageSize?: string;
                /**
                 * @description 排序字段
                 * @example createTime
                 */
                orderBy?: "userId" | "ticketNo" | "orderNo" | "settledStatus" | "settledTime" | "createTime";
                /** @description 排序方向：ASC或DESC */
                orderDirection?: "ASC" | "DESC";
                /**
                 * @description 是否需要返回总数
                 * @example true
                 */
                needTotalCount?: "true" | "false";
            };
            header?: {
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBetsTicketPageResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getCashoutAmount: {
        parameters: {
            query: {
                ticketNo: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCashoutQuoteApiResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getUserCarts_1: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseBetsCartResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getTicketsRecommendationAmounts: {
        parameters: {
            query: {
                currency: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseFrontendRecommendationVO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getTickets_1: {
        parameters: {
            query?: {
                /**
                 * @description 页码，从1开始
                 * @example 1
                 */
                pageIndex?: string;
                /**
                 * @description 每页大小，最大100
                 * @example 10
                 */
                pageSize?: string;
                /**
                 * @description 是否需要返回总数
                 * @example false
                 */
                needTotalCount?: "true" | "false";
            };
            header?: {
                "Accept-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBetsTicketPageResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getWinRateLeaderboard: {
        parameters: {
            query?: {
                topSize?: number;
            };
            header: {
                "Accept-Language": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseWinRateRankResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getTurnoverLeaderboard: {
        parameters: {
            query?: {
                topSize?: number;
            };
            header: {
                "Accept-Language": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseTurnoverRankResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getTicketsComboTypes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseComboTypeApiResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getTicketsCashoutRules: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCashoutMarketRuleResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getUserTicketsCount: {
        parameters: {
            query?: {
                /**
                 * @description 结算状态列表 0:未结算 10:输 20:赢 30:半赢 40:半输 50:走盘 60:取消 70:cashed out 80:退款 100:错误
                 * @example 0, 10, 20, 30, 40, 50, 60, 70, 80, 100
                 */
                settledStatus?: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
}
export enum ApiPaths {
    hasPlaced = "/openfeign/ticket/hasPlaced",
    batchGetCopyTradeCount = "/openfeign/ticket/copyTradeCount",
    syncTickets = "/openapi/order/tickets/sync",
    syncTickets_1 = "/openfeign/order/tickets/sync",
    cashout = "/openfeign/order/tickets/cashout",
    cashout_1 = "/openapi/order/tickets/cashout",
    syncSelection = "/openapi/order/selection/sync",
    syncSelection_1 = "/openfeign/order/selection/sync",
    testReportCluster = "/internal/kafka/test/report",
    refreshPartitions = "/internal/kafka/test/refresh-partitions",
    testPrimaryCluster = "/internal/kafka/test/primary",
    createOrderUserPlace = "/api/order/user/v2/place",
    maxStake = "/api/order/user/v2/maxStake",
    saveCart = "/api/order/user/v2/cart",
    deleteCart = "/api/order/user/v2/cart/delete",
    clearUserCarts = "/api/order/user/v2/cart/clear",
    processCashout = "/api/order/user/tickets/cashout/process",
    createOrder_1 = "/api/order/user/place",
    maxStake_1 = "/api/order/user/maxStake",
    clearUserCarts_1 = "/api/order/user/carts/clear",
    saveCart_1 = "/api/order/user/cart",
    deleteCart_1 = "/api/order/user/cart/delete",
    syncTranslations = "/api/order/i18n/syncTranslations",
    init = "/api/order/i18n/init",
    initCrowdin = "/api/order/i18n/initCrowdin",
    getPartitionInfo = "/internal/kafka/test/partitions",
    healthCheck = "/internal/kafka/test/health",
    getClusterConfig = "/internal/kafka/test/config",
    getByUserId = "/api/order/virtual-bet-user/{userId}",
    randomUsers = "/api/order/virtual-bet-user/random",
    listAll = "/api/order/virtual-bet-user/all",
    listActiveUsers = "/api/order/virtual-bet-user/active",
    listComboTypes = "/api/order/user/v2/combo/types",
    getUserCarts = "/api/order/user/v2/cart/all",
    getUserTicketsPage = "/api/order/user/tickets/page",
    getCashoutAmount = "/api/order/user/tickets/cashout/amount",
    getUserCarts_1 = "/api/order/user/carts/all",
    getTicketsRecommendationAmounts = "/api/order/tickets/recommendation/amounts",
    getTickets_1 = "/api/order/tickets/page",
    getWinRateLeaderboard = "/api/order/tickets/leaderboard/winrate",
    getTurnoverLeaderboard = "/api/order/tickets/leaderboard/turnover",
    getTicketsComboTypes = "/api/order/tickets/combo/types",
    getTicketsCashoutRules = "/api/order/tickets/cashout/rules",
    getUserTicketsCount = "/api/order/user/tickets/count"
}
